export interface VerifactuTaxAuthority {
  errors: VerifactuTaxAuthorityError[];
  identifier: string;
  qrContent: string;
  registeredAt: string;
  status: VerifactuTaxAuthorityStatus;
}

export interface VerifactuTaxAuthorityError {
  code: string;
  message: string;
}

export enum VerifactuTaxAuthorityStatus {
  NotRegistered = 'NOT_REGISTERED',
  Error = 'ERROR',
  Registered = 'REGISTERED',
  RegisteredWithErrors = 'REGISTERED_WITH_ERRORS',
  Rejected = 'REJECTED',
}
